/**
 * 知识库 API服务
 */
import { escRequest } from '@/common/request-esc';

// @ts-ignore
const API_BASE_URL = `${import.meta.env.VITE_SAFE_HOST}/api`;

// 0：待解析，1: 解析中，2：解析成功，3：解析失败
export enum EmbeddingStatus {
  WaitParse = 0,
  Parsing,
  Success,
  Failed,
}

export enum UserAccess {
  None = 0,
  Readable,
  Writable,
}

export enum UserRole {
  Member = 1,
  Admin,
  Owner,
}

export enum FileTreeNodeType {
  RootGroup = 0,
  Directory,
  File,
}

export enum FileTreeNodeSpace {
  Root = 0,
  Personal,
  Group,
}

export interface KbNode {
  title: string;
  uuid: string;
  file_id: string;
  file_ext: string;
  type: FileTreeNodeType;
  space: FileTreeNodeSpace;
  emb_status: EmbeddingStatus;
  access: UserAccess;
  role: UserRole;
  visible: 0 | 1;
  user_visible: 0 | 1;
  children?: KbNode[];
}

/**
 * 获取Agent列表数据
 * @returns {Promise<Object>} 返回包含featuredAgents、moreAgents和agentCategories的数据
 */
export const getKbTreeData = () => {
  return escRequest<{ tree: KbNode[] }>({
    url: `${API_BASE_URL}/rag/node/tree`,
  });
};

export const getUploadUrl = (fileName: string, fileSize: number) => {
  return escRequest<{ url: string; file_id: string }>({
    url: `${API_BASE_URL}/llm/chat/file/upload`,
    method: 'POST',
    params: { fileName, fileSize },
  });
};

export const uploadFile = (url: string, file: File) => {
  return fetch(url, {
    method: 'PUT',
    body: file,
  });
};

export const triggerFileEmbedding = (file_id: string) => {
  return escRequest<{ file_url: string; file_name: string; file_id: string }>({
    url: `${API_BASE_URL}/llm/chat/file/embed`,
    method: 'POST',
    params: { file_id }
  });
};
